export type InstallPlatform = 'ios' | 'android' | 'other';

export interface InstallHintInput {
  platform: InstallPlatform;
  isStandalone: boolean; // already installed / running as app
  dismissed: boolean; // user dismissed the hint before
  canPrompt: boolean; // a beforeinstallprompt event was captured
  pathname?: string | null; // current route; some routes never show the hint
}

export interface InstallHintState {
  show: boolean;
  mode: 'ios' | 'android' | null;
}

// Routes where the hint never shows: the login page ('/'), and the screens
// the PATIENT holds (the receipt signing screen and the aviso de privacidad
// signing screen) — staff chrome must not appear there.
export function isInstallHintRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return true;
  if (pathname === '/') return false;
  if (pathname === '/tickets/firmar' || pathname.startsWith('/tickets/firmar/')) return false;
  if (pathname === '/pacientes/aviso' || pathname.startsWith('/pacientes/aviso/')) return false;
  return true;
}

// Pure decision for the install hint. iOS has no prompt API, so it always
// gets the manual "••• → Compartir → Agregar a inicio" tip; Android/desktop
// only show once the browser fires beforeinstallprompt.
export function shouldShowInstallHint({ platform, isStandalone, dismissed, canPrompt, pathname }: InstallHintInput): InstallHintState {
  if (isStandalone || dismissed) return { show: false, mode: null };
  if (pathname !== undefined && !isInstallHintRoute(pathname)) return { show: false, mode: null };
  if (platform === 'ios') return { show: true, mode: 'ios' };
  if (canPrompt) return { show: true, mode: 'android' };
  return { show: false, mode: null };
}
